import { render, staticRenderFns } from "./closing.vue?vue&type=template&id=abf7489a&scoped=true"
import script from "./closing.vue?vue&type=script&lang=js"
export * from "./closing.vue?vue&type=script&lang=js"
import style0 from "./closing.vue?vue&type=style&index=0&id=abf7489a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf7489a",
  null
  
)

export default component.exports